import React, { CSSProperties, FC, ReactNode, RefObject } from 'react';
import cn from 'classnames';
import SwiperCarouselContainer from './SwiperCarouselContainer';
import SwiperCarouselArrows from './SwiperCarouselArrows';
import { createArrows } from './helpers/createArrows';
require("./SwiperCarousel.css");
var styles = {
  "Root": "SwiperCarousel-module-Root_2HI",
  "RootNoOverflow": "SwiperCarousel-module-RootNoOverflow_Au3"
};
const defaultBreakpoints = {
  '768': {
    slidesPerView: 4,
    spaceBetween: 24
  },
  '992': {
    slidesPerView: 5
  },
  '1200': {
    slidesPerView: 6
  }
};
export const SwiperCarousel = ({
  controlRef,
  innerRef,
  className,
  slides,
  slidesPerView = 'auto',
  slidesPerGroup = 1,
  navigation = true,
  autoplay = false,
  autoplayDelay = 3500,
  autoplayDisableOnInteraction = false,
  autoplayPauseOnMouseEnter = false,
  spaceBetween = 16,
  loop = false,
  isOverflowVisible = false,
  breakpoints = defaultBreakpoints,
  containerClassName = '',
  slideClassName = '',
  onInit,
  onRealIndexChange,
  onActiveIndexChange,
  onAfterInit,
  onBeforeDestroy,
  onBeforeInit,
  onDestroy,
  onResize,
  onSlidesLengthChange,
  onSlidesUpdated,
  onUpdate,
  style = {}
}) => {
  if (!slides.length) {
    return null;
  }
  if (slidesPerView !== 'auto' && slidesPerGroup > slidesPerView) {
    slidesPerGroup = slidesPerView;
  }
  const {
    prevEl,
    nextEl,
    arrows
  } = createArrows();
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, {
      [styles.RootNoOverflow]: isOverflowVisible
    }, className),
    style: style,
    ref: innerRef || controlRef
  }, /*#__PURE__*/React.createElement(SwiperCarouselContainer, {
    slides: slides,
    slidesPerView: slidesPerView,
    slidesPerGroup: slidesPerGroup,
    arrows: arrows,
    autoplay: autoplay,
    autoplayDelay: autoplayDelay,
    autoplayDisableOnInteraction: autoplayDisableOnInteraction,
    autoplayPauseOnMouseEnter: autoplayPauseOnMouseEnter,
    spaceBetween: spaceBetween,
    loop: loop,
    breakpoints: breakpoints,
    containerClassName: containerClassName,
    slideClassName: slideClassName,
    onInit: onInit,
    onRealIndexChange: onRealIndexChange,
    onActiveIndexChange: onActiveIndexChange,
    onAfterInit: onAfterInit,
    onBeforeDestroy: onBeforeDestroy,
    onBeforeInit: onBeforeInit,
    onDestroy: onDestroy,
    onResize: onResize,
    onSlidesLengthChange: onSlidesLengthChange,
    onSlidesUpdated: onSlidesUpdated,
    onUpdate: onUpdate
  }), navigation && /*#__PURE__*/React.createElement(SwiperCarouselArrows, {
    prevEl: prevEl,
    nextEl: nextEl
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SwiperCarousel.displayName = 'SwiperCarousel';
}